'use strict';

var React = require('react');

var SvgCircleMinusOutlineMinor = function SvgCircleMinusOutlineMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 2c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 14c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zm-3-7a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6z"
  }));
};

exports.SvgCircleMinusOutlineMinor = SvgCircleMinusOutlineMinor;
